import React, { lazy } from "react"
import { Common } from "lib/types"
import { ReactComponent as SettingsIcon } from "images/icons/gear.svg"
import { PermissionGroups } from "../constants"

const Settings = lazy(() => import("views/Settings").then(m => ({ default: m.Settings })))
const UsagePlan = lazy(() => import("views/Settings").then(m => ({ default: m.UsagePlan })))
const ExternalEvents = lazy(() => import("views/Settings").then(m => ({ default: m.ExternalEvents })))
const ApiClients = lazy(() => import("views/Settings").then(m => ({ default: m.ApiClients })))
const Credentials = lazy(() => import("views/Settings/Credentials/Credentials"))
const CreateApiDestination = lazy(() => import("views/Settings/ExternalEvents/DestinationAPIs/CreateApiDestination"))
const UpdateApiDestination = lazy(() => import("views/Settings/ExternalEvents/DestinationAPIs/UpdateApiDestination"))
const ShowUsers = lazy(() => import("views/Users/ShowUsers").then(m => ({ default: m.ShowUsers })))
const User = lazy(() => import("views/Users/User").then(m => ({ default: m.User })))

const Providers = lazy(() => import("views/Settings").then(m => ({ default: m.Providers })))
const ShowProviders = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.ShowProviders })))
const AdyenConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.AdyenConfiguration })))
const KustomConfig = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.KustomConfig })))
const SveaConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.SveaConfiguration })))
const IngridConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.IngridConfiguration })))
const Retain24Config = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.Retain24Config })))
const NShiftConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.NShiftConfiguration })))
const VoyadoConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.VoyadoConfiguration })))
const WalleyConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.WalleyConfiguration })))
const BonusConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.BonusConfiguration })))
const ExternalPriceConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.ExternalPriceConfiguration })))
const QliroOneConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.QliroOneConfiguration })))
const QliroLoyaltyConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.QliroLoyaltyConfiguration })))
const AvardaConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.AvardaConfiguration })))
const ZaverConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.ZaverConfiguration })))
const LedyerConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.LedyerConfiguration })))
const CustomPaymentConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.CustomPaymentConfiguration })))
const TaxJarConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.TaxJarConfiguration })))
const CustomGiftCardConfiguration = lazy(() => import("views/Settings/Providers").then(m => ({ default: m.CustomGiftCardConfiguration })))

export const settingsRoutes: Common.Views = [
  {
    element: <Settings />,
    path: "/settings",
    title: "Settings",
    icon: SettingsIcon,
    sortOrder: 7,
    children: [
      {
        element: <Providers />,
        path: "/settings/providers",
        title: "Providers",
        parentPath: "/settings",
        requiredGroups: PermissionGroups.providers.read,
        section: "Connections",
        children: [
          {
            element: <ShowProviders />,
            path: "/settings/providers",
            title: "Show Providers",
            parentPath: "/settings"
          },
          {
            element: <AdyenConfiguration />,
            path: "/settings/providers/adyen",
            title: "Adyen",
            parentPath: "/settings/providers"
          },
          {
            element: <KustomConfig />,
            path: "/settings/providers/kustom",
            title: "Kustom",
            parentPath: "settings/providers"
          },
          {
            element: <SveaConfiguration />,
            path: "/settings/providers/svea",
            title: "Svea",
            parentPath: "/settings/providers"
          },
          {
            element: <IngridConfiguration />,
            path: "/settings/providers/ingrid",
            title: "Ingrid",
            parentPath: "/settings/providers"
          },
          {
            element: <Retain24Config />,
            path: "/settings/providers/retain24",
            title: "Retain24",
            parentPath: "/settings/providers"
          },
          {
            element: <NShiftConfiguration />,
            path: "/settings/providers/Nshift",
            title: "nShift",
            parentPath: "/settings/providers"
          },
          {
            element: <VoyadoConfiguration />,
            path: "/settings/providers/voyado",
            title: "Voyado",
            parentPath: "/settings/providers"
          },
          {
            element: <WalleyConfiguration />,
            path: "/settings/providers/walley",
            title: "Walley",
            parentPath: "/settings/providers"
          },
          {
            element: <BonusConfiguration />,
            path: "/settings/providers/bonus",
            title: "Bonus providers",
            parentPath: "/settings/providers"
          },
          {
            element: <ExternalPriceConfiguration />,
            path: "/settings/providers/external-price",
            title: "External Price providers",
            parentPath: "/settings/providers"
          },
          {
            element: <QliroOneConfiguration />,
            path: "/settings/providers/qliro",
            title: "Qliro One",
            parentPath: "/settings/providers"
          },
          {
            element: <QliroLoyaltyConfiguration />,
            path: "/settings/providers/qliro-loyalty",
            title: "Qliro Loyalty",
            parentPath: "/settings/providers"
          },
          {
            element: <AvardaConfiguration />,
            path: "/settings/providers/avarda",
            title: "Avarda",
            parentPath: "/settings/providers"
          },
          {
            element: <ZaverConfiguration />,
            path: "/settings/providers/zaver",
            title: "Zaver",
            parentPath: "/settings/providers"
          },
          {
            element: <LedyerConfiguration />,
            path: "/settings/providers/ledyer",
            title: "Ledyer",
            parentPath: "/settings/providers"
          },
          {
            element: <CustomPaymentConfiguration />,
            path: "/settings/providers/custom-payment",
            title: "Custom Payment",
            parentPath: "/settings/providers"
          },
          {
            element: <TaxJarConfiguration />,
            path: "/settings/providers/tax-jar",
            title: "TaxJar",
            parentPath: "/settings/providers"
          },
          {
            element: <CustomGiftCardConfiguration />,
            path: "/settings/providers/bsg-gift-card",
            title: "Brink Custom Gift Card",
            parentPath: "/settings/providers"
          }
        ]
      }
    ]
  },
  {
    element: <ExternalEvents />,
    path: "/settings/external-events",
    parentPath: "/settings",
    title: "External events",
    requiredGroups: PermissionGroups.externalEvents.read
  },
  {
    element: <CreateApiDestination />,
    path: "/settings/external-events/create-api-destination",
    parentPath: "/settings/external-events",
    title: "Create API destination",
    requiredGroups: PermissionGroups.externalEvents.write
  },
  {
    element: <UpdateApiDestination />,
    path: "/settings/external-events/update-api-destination/:name",
    parentPath: "/settings/external-events",
    title: "Update API destination",
    requiredGroups: PermissionGroups.externalEvents.read
  },
  {
    element: <UsagePlan />,
    path: "/settings/usage-plan",
    parentPath: "/settings",
    title: "Usage plan",
    section: "Brink configurations",
    requiredGroups: PermissionGroups.system.read
  },
  {
    element: <Credentials />,
    path: "/settings/credentials",
    parentPath: "/settings",
    title: "Credentials",
    requiredGroups: PermissionGroups.system.read
  },
  {
    element: <ApiClients />,
    path: "/settings/api-configs",
    parentPath: "/settings",
    title: "API clients",
    requiredGroups: PermissionGroups.apiClients.read
  },
  {
    element: <ShowUsers />,
    path: "/settings/manage-users",
    parentPath: "/settings",
    title: "Manage users",
    section: "Users",
    requiredGroups: PermissionGroups.users.read
  },
  {
    element: <User />,
    path: "/user"
  }
]
